import { MenuType } from 'modules/types/account';

export const getLocationPaths = (pathname: string) => {
  return pathname.split('/').slice(1);
};

export const getCurrentPathName = (paths: string[]) => {
  return paths.join('/');
};

export const getDefaultMenuKey = (menus: MenuType[]) => {
  const defaultIndex = menus.findIndex((menu: MenuType) => !!menu.default);
  const defaultMenu = !!~defaultIndex ? menus[defaultIndex] : menus[0];
  return defaultMenu && defaultMenu.key;
};
